import { formatCssUnit } from '../../common/format-css-unit';

export function safeApplyCssUnit(
	element: HTMLElement,
	prop: string,
	value: number | string | undefined
) {
	if (value || value === 0) {
		element.style[prop] = formatCssUnit(value);
	}
}
